/* eslint-disable @typescript-eslint/no-explicit-any */
import type { BootcampDelivery, NucampUser } from "$lib/datamodel";
import { fetchRetry } from "$lib/helpers";
import { auth } from "../firebase";
import { followBootcampEvent } from "./analytics";
import { AddUserToBootcampFollowStream } from "./nurture";

export function getNextBootcampDeliverybyBootcamp(bootcampId: string, communityId: string = "", days: number = 0) {
  const data = { 
    bootcampId,
    communityId,
    days: days ?? 0,
    next: true
  };
  const searchParams = new URLSearchParams(data as any);
  const searchParamsString = searchParams.toString();
  return fetchRetry('/api/bootcampdelivery?' + searchParamsString, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
    },
  }, {retries: 3, retryDelay: 500})
  .then((res) => {
    return res.json();
  })
}

export async function addUserToBootcampFollowList(user: NucampUser, bootcamp: BootcampDelivery) {
  let medium = "";
  let keyword = "";
  if (window && window?.location?.pathname?.includes("/blog/")) {
    medium = "blog";
    keyword = window.location.pathname.split('/').pop() || "";
  }
  if (bootcamp) {
    const authToken = await auth?.currentUser?.getIdToken();
    const addUserToBootcamDeliveryFollowList = fetch('/api/bootcampdelivery/followers', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({userUID: user.uid, bootcampId: bootcamp.id, authToken})
    })
    await Promise.all([
      followBootcampEvent(bootcamp, bootcamp.cost.earlybird, {...user, location: bootcamp.community.community.city, state: bootcamp.community.community.state}, medium, keyword),
      AddUserToBootcampFollowStream({...user, communityUrlId: bootcamp.community.urlId}, bootcamp.community.community.name, bootcamp.community.community.state, bootcamp.nucampFlex, bootcamp.mautic.nurture_prospectid),
      addUserToBootcamDeliveryFollowList
    ])
  } else {
    await AddUserToBootcampFollowStream(user, "", "", false, 52);
  }

}